export default __webpack_public_path__ + "static/data-about-screenshot-1-ba988d45fafebb1ca9b5f9069b165f73.png";